import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import dayjs from 'dayjs';
export default {
  name: 'website_article',
  props: {
    currentNavigation: {
      type: Object
    }
  },
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        editPageName: '官网文章',
        addFunName: 'articleAdd',
        modifyFunName: 'articleModify',
        delFunName: 'articleDel',
        queryFunName: 'articleQuery',
        detailFunName: 'articleDetail',
        dicTreeFunName: 'dictionaryCache'
      },
      dicData: {
        upperCode: this.currentNavigation.useDics,
        configCategorys: [],
        configCategoryOptions: {}
      },
      searchForm: {
        page: 1,
        limit: 10,
        searchKey: null,
        sortField: 'create_time',
        navId: this.currentNavigation.id
      },
      formData: {
        id: null,
        navId: this.currentNavigation.id,
        title: null,
        subTitle: null,
        category: null,
        author: null,
        content: null,
        releaseTime: null,
        listImg: null,
        listRemark: null,
        casesImgList: null,
        casesImgArray: [],
        indexImg: null,
        indexImgAlt: null,
        detailImg: null,
        detailImgAlt: null,
        viewsCount: null,
        videos: null,
        files: null
      },
      rules: {
        name: [{
          required: true,
          message: '标题不能为空',
          trigger: 'blur'
        }]
      },
      queryLoading: true,
      tableData: [],
      totalCount: 0,
      editDialogShow: false,
      editDialogTitle: '',
      formLabelWidth: '100px',
      emptyFormData: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.emptyFormData = JSON.parse(JSON.stringify(this.formData));
    if (this.dicData.upperCode) {
      this.$api[this.pageConfig.dicTreeFunName](this.dicData.upperCode).then(function (res) {
        if (res.data) {
          _this.dicData.configCategorys = res.data;
          for (var i = 0; i < res.data.length; i++) {
            _this.dicData.configCategoryOptions[res.data[i].code] = res.data[i].name;
          }
        }
      });
    }
    this.query();
  },
  methods: {
    back: function back() {
      this.$emit('child-go-navigation');
    },
    initFormData: function initFormData(data) {
      var paramData = JSON.parse(JSON.stringify(data));
      if (paramData.releaseTime) {
        paramData.releaseTime = paramData.releaseTime.toString();
      }
      if (paramData.casesImgList) {
        paramData.casesImgArray = JSON.parse(paramData.casesImgList);
      } else {
        paramData.casesImgArray = [];
      }
      this.formData = paramData;
      if (typeof this.$refs['formDataVerify'] !== 'undefined') {
        this.$refs['formDataVerify'].clearValidate();
      }
    },
    saveFormDataProcess: function saveFormDataProcess(formData) {
      var saveFormData = JSON.parse(JSON.stringify(formData));
      if (saveFormData.casesImgArray) {
        saveFormData.casesImgList = JSON.stringify(saveFormData.casesImgArray);
      }
      return saveFormData;
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isImage = ['image/jpeg', 'image/jpg', 'image/png'].includes(file.type);
      if (!isImage) {
        this.$message.error('文件必须是图片格式');
      }
      var isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('图片大小不超过5M！');
      }
      return isImage && isLt5M;
    },
    previewFile: function previewFile(path) {
      window.open(path);
    },
    uploadListImage: function uploadListImage(_ref) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var file;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              file = _ref.file;
              _this2.$api.aliOssSign(localStorage.getItem('userId')).then(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return _this2.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this2.formData.listImg = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    removeListImageFile: function removeListImageFile() {
      this.formData.listImg = '';
    },
    uploadIndexImage: function uploadIndexImage(_ref3) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var file;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              file = _ref3.file;
              _this3.$api.aliOssSign(localStorage.getItem('userId')).then(/*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(res) {
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return _this3.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this3.formData.indexImg = _context3.sent;
                      case 3:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x2) {
                  return _ref4.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    removeIndexImageFile: function removeIndexImageFile() {
      this.formData.indexImg = '';
    },
    uploadDetailImg: function uploadDetailImg(_ref5) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var file;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              file = _ref5.file;
              _this4.$api.aliOssSign(localStorage.getItem('userId')).then(/*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(res) {
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        _context5.next = 2;
                        return _this4.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        _this4.formData.detailImg = _context5.sent;
                      case 3:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x3) {
                  return _ref6.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    removeDetailImgFile: function removeDetailImgFile() {
      this.formData.detailImg = '';
    },
    uploadCaseImage: function uploadCaseImage(_ref7) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var file;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              file = _ref7.file;
              _this5.$api.aliOssSign(localStorage.getItem('userId')).then(/*#__PURE__*/function () {
                var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(res) {
                  var filePath;
                  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        _context7.next = 2;
                        return _this5.uploadFile(localStorage.getItem('userId'), dayjs().format('YYYYMMDD'), res.data, file);
                      case 2:
                        filePath = _context7.sent;
                        _this5.formData.casesImgArray.push({
                          uid: file.uid,
                          url: filePath
                        });
                      case 4:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7);
                }));
                return function (_x4) {
                  return _ref8.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    previewCaseImageFile: function previewCaseImageFile(file) {
      window.open(file.url);
    },
    removeCaseImageFile: function removeCaseImageFile(file, fileList) {
      for (var i in this.formData.casesImgArray) {
        if (this.formData.casesImgArray[i].uid === file.uid) {
          this.formData.casesImgArray.splice(i, 1);
        }
      }
    },
    add: function add() {
      this.editDialogTitle = this.pageConfig.editPageName + '新增';
      this.editDialogShow = true;
    },
    edit: function edit(id) {
      var _this6 = this;
      this.$api[this.pageConfig.detailFunName](id).then(function (res) {
        _this6.initFormData(res.data);
        _this6.editDialogTitle = _this6.pageConfig.editPageName + '维护';
        _this6.editDialogShow = true;
      });
    },
    del: function del(id) {
      var _this7 = this;
      this.$confirm('确定要删除吗').then(function () {
        _this7.$api[_this7.pageConfig.delFunName](id).then(function (res) {
          if (res.data) {
            _this7.$message.success('删除成功');
            _this7.query();
          } else {
            _this7.$message.error('删除失败');
          }
        });
      });
    },
    query: function query() {
      var _this8 = this;
      this.queryLoading = true;
      this.$api[this.pageConfig.queryFunName](this.searchForm).then(function (res) {
        _this8.tableData = res.data || [];
        _this8.totalCount = res.count;
        _this8.queryLoading = false;
      });
    },
    submitFormData: function submitFormData() {
      var _this9 = this;
      this.$refs['formDataVerify'].validate(function (valid) {
        if (valid) {
          if (_this9.formData.id) {
            _this9.$api[_this9.pageConfig.modifyFunName](_this9.saveFormDataProcess(_this9.formData)).then(function (res) {
              if (res.data) {
                _this9.$message.success('编辑成功');
                _this9.initFormData(_this9.emptyFormData);
                _this9.editDialogShow = false;
                _this9.query();
              } else {
                _this9.$message.error('编辑失败');
              }
            });
          } else {
            _this9.$api[_this9.pageConfig.addFunName](_this9.saveFormDataProcess(_this9.formData)).then(function (res) {
              if (res.data) {
                _this9.$message.success('新增成功');
                _this9.initFormData(_this9.emptyFormData);
                _this9.editDialogShow = false;
                _this9.query();
              } else {
                _this9.$message.error('新增失败');
              }
            });
          }
        }
      });
    },
    closeEditDialogShow: function closeEditDialogShow() {
      this.editDialogTitle = '';
      this.editDialogShow = false;
      this.initFormData(this.emptyFormData);
    },
    search: function search() {
      this.searchForm.page = 1;
      this.query();
    },
    pageChange: function pageChange(page) {
      this.searchForm.page = page;
      this.query();
    },
    sizeChange: function sizeChange(limit) {
      this.searchForm.page = 1;
      this.searchForm.limit = limit;
      this.query();
    },
    sortChange: function sortChange(column) {
      this.searchForm.page = 1;
      this.searchForm.sortField = column.order === 'ascending' ? '^' + this.camelToUnderline(column.prop) : column.order === 'descending' ? this.camelToUnderline(column.prop) : 'create_time';
      this.query();
    }
  }
};